var MetaTag;
(function(MetaTag2) {
  MetaTag2["OG_URL"] = "og:url";
  MetaTag2["OG_SITE_NAME"] = "og:site_name";
  MetaTag2["OG_IMAGE"] = "og:image";
  MetaTag2["OG_IMAGE_ALT"] = "og:image:alt";
  MetaTag2["OG_TITLE"] = "og:title";
  MetaTag2["OG_TYPE"] = "og:type";
  MetaTag2["OG_DESCRIPTION"] = "og:description";
  MetaTag2["FB_APP_ID"] = "fb:app_id";
  MetaTag2["FB_PAGE_ID"] = "fb:page_id";
  MetaTag2["DESCRIPTION"] = "description";
  MetaTag2["KEYWORDS"] = "keywords";
  MetaTag2["ROBOTS"] = "robots";
  MetaTag2["PRERENDER_STATUS_CODE"] = "prerender-status-code";
})(MetaTag || (MetaTag = {}));
class MetaService {
  constructor() {
    this.metas = new Map();
  }
  setDefaultTagInformation(meta2) {
    this.metas.set(meta2.name, meta2.content);
    this.setMetaTag(meta2);
  }
  setMetaTag(meta2) {
    const content = meta2.content || this.metas.get(meta2.name);
    if (!content) {
      this.removeTag(meta2.name);
      return;
    }
    const tag = this.findOrCreateTag(meta2.name);
    tag.setAttribute("content", content);
  }
  setTitle(title) {
    if (!title) {
      return;
    }
    const titleTag = document.querySelector("title");
    titleTag.innerText = title;
  }
  findOrCreateTag(name) {
    const tag = this.getTag(name);
    if (tag) {
      return tag;
    }
    const createdTag = document.createElement("meta");
    if (this.isProperty(name)) {
      createdTag.setAttribute("property", name);
    } else {
      createdTag.setAttribute("name", name);
    }
    document.head.appendChild(createdTag);
    return createdTag;
  }
  removeTag(name) {
    const tag = this.getTag(name);
    if (!tag) {
      return;
    }
    tag.parentElement.removeChild(tag);
  }
  getTag(name) {
    if (this.isProperty(name)) {
      return document.querySelector(`meta[property='${name}']`);
    }
    return document.querySelector(`meta[name='${name}']`);
  }
  isProperty(name) {
    return name.startsWith("og:") || name.startsWith("fb:");
  }
}
const meta = new MetaService();

export { MetaService, MetaTag, meta };
